import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import I18n from 'translations/i18n'

import { Flex } from 'components/global/atoms'
import JisrLoader from 'components/global/JisrLoader'

import EmployeeComponent from './EmployeeComponent'
import CheckAll from './CheckAll'
import SearchArea from './SearchArea'
import EligiblePeopleFilters from './Filters'

// TODO (rohan): refactor this component, its become extremely confusing
function EligiblePeople(props) {
  const {
    filters,
    flowType,
    noBorder,
    onChange,
    selectedUsers = [],
    typeId = '',
    policyId,
    clearEligibleData,
    eligiblePeopleLoad,
    fetching,
    filterEligiblePeopleLoad,
    searchSelected,
    searchUnSelected,
    selected,
    selectUser,
    setSelectAllUsers,
    setSelectUsers,
    setUnSelectAllUsers,
    un_selected,
    archive_selected,
    unSelectUser,
    searchProps,
  } = props
  const memeoData = React.useMemo(() => !isEmpty(selectedUsers), [selectedUsers])
  const memoTypeId = React.useMemo(() => typeId, [typeId])
  const [disableSelectAll, setDisableSelectAll] = useState(false)
  function onSubmitFilters(filter) {
    filterEligiblePeopleLoad({
      flow_type: flowType,
      type_id: typeId,
      policy_id: policyId,
      filter,
    })
  }

  React.useEffect(() => {
    // if (memeoData) {
    setSelectUsers(selectedUsers)
    // }
  }, [memeoData])

  React.useEffect(() => {
    onChange({
      selected,
      un_selected,
      archive_selected,
    })
  }, [selected, un_selected])

  React.useEffect(() => {
    eligiblePeopleLoad({
      flow_type: flowType,
      type_id: typeId,
      policy_id: policyId,
    })
    if (memoTypeId) return () => clearEligibleData()
    return () => {}
  }, [memoTypeId])

  return (
    <div
      className={classNames('jisr-eligible-people', !noBorder && 'jisr-eligible-people_bordered')}
    >
      {fetching && <JisrLoader absolute />}
      <div className="jisr-eligible-people_header">
        <CheckAll
          isCheckAll={isEmpty(un_selected)}
          checkedAll={setSelectAllUsers}
          unCheckedAll={setUnSelectAllUsers}
          disableSelectAll={disableSelectAll}
        />
        {!isEmpty(un_selected) && (
          <Flex alignEnd>
            <EligiblePeopleFilters
              filters={filters}
              setDisableSelectAll={setDisableSelectAll}
              onSubmit={onSubmitFilters}
            />
          </Flex>
        )}
      </div>
      <SearchArea
        searchUnSelected={searchUnSelected}
        searchSelected={searchSelected}
        searchProps={searchProps}
        setDisableSelectAll={setDisableSelectAll}
      />
      <div className="flex">
        <div className="jisr-eligible-people__selected scroll-y">
          {un_selected.map((employee, i) => (
            <EmployeeComponent
              checked={false}
              employee={employee}
              key={i}
              onClick={selectUser}
            />
          ))}
          {!un_selected.length && <p className="text-center">{I18n.t('no_data')}</p>}
        </div>
        <div className="jisr-eligible-people__unselected scroll-y">
          {selected.map((employee, i) => (
            <EmployeeComponent
              checked
              employee={employee}
              key={i}
              onClick={unSelectUser}
            />
          ))}
          {!selected.length && <p className="text-center">{I18n.t('no_data')}</p>}
        </div>
      </div>
    </div>
  )
}
EligiblePeople.propTypes = {
  clearEligibleData: PropTypes.func,
  eligiblePeopleLoad: PropTypes.func,
  onChange: PropTypes.func,
  searchSelected: PropTypes.func,
  searchUnSelected: PropTypes.func,
  selectUser: PropTypes.func,
  setSelectAllUsers: PropTypes.func,
  setSelectUsers: PropTypes.func,
  setUnSelectAllUsers: PropTypes.func,
  unSelectUser: PropTypes.func,
  filterEligiblePeopleLoad: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.string),
  selected: PropTypes.arrayOf(PropTypes.shape()),
  selectedUsers: PropTypes.arrayOf(PropTypes.shape()),
  un_selected: PropTypes.arrayOf(PropTypes.shape()),
  archive_selected: PropTypes.arrayOf(PropTypes.shape()),
  flowType: PropTypes.string,
  typeId: PropTypes.string,
  policyId: PropTypes.string,
  searchProps: PropTypes.shape(),

  noBorder: PropTypes.bool,
  fetching: PropTypes.bool,
}

export default EligiblePeople
